
import { getDataCanChuyenLocal } from "../db/report/canchuyen"
import { isLocalMode } from "../utils/common"
import ApiHelper from "./ApiHelper"

export const CanChuyen = {
    getCanChuyenParams: async (payload) => {
        const { contactId, daiList } = payload
        let result = await ApiHelper.get(`CC/getCanChuyenParams?contactId=${contactId}` +
            `&daiList=${daiList}`)
        return result
    },
    getDataCanChuyen: async (payload) => {
        if (isLocalMode()) {
            return getDataCanChuyenLocal(payload)
        } else {
            const { userId, daiList, loaiCuocList, date, contactId } = payload
            let result = await ApiHelper.get(`CC/getDataCanChuyen?userId=${userId}` +
                `&date=${date}` +
                `&daiList=${daiList}&loaiCuocList=${loaiCuocList}&contactId=${contactId}`)
            return result.data
        }
    },
    getCountTinChuyenDi: async (payload) => {
        const { date, contactId } = payload
        let result = await ApiHelper.get(`CC/getCountTinChuyenDi?` +
            `date=${date}` +
            `&contactId=${contactId}`)
        return result.data
    },
    getCanChuyenParamGroups: async (payload) => {
        const { contactId, daiList } = payload
        let result = await ApiHelper.get(`CC/getCanChuyenParamGroups?contactId=${contactId}` +
            `&daiList=${daiList}`)
        return result
    },
    getCanChuyenParamGroupsAll: async (payload) => {
        const { contactId } = payload
        let result = await ApiHelper.get(`CC/getCanChuyenParamGroupsAll?contactId=${contactId}`)
        return result.data
    },
    saveCanChuyenParamGroups: async (payload) => {
        //
        let { dataRows, ngoaiLeText, contactId, json } = payload
        if (!ngoaiLeText || ngoaiLeText == undefined) {
            ngoaiLeText = ""
        }
        let body = { body: dataRows, ngoaiLeText: ngoaiLeText, contactId: contactId, json: json }
        let result = await ApiHelper.post(`CC/saveCanChuyenParamGroups`, body)
        return result
    },
    getTicketMB: async (payload) => {
        const { ngay, muc1, muc2, muc3 } = payload
        let result = await ApiHelper.get(`/parser/getTicketMB?ngay=${ngay}&muc1=${muc1}&muc2=${muc2}&muc3=${muc3}`)
        return result.data
    },
    getKQTTMB: async (payload) => {
        const { ngay } = payload
        let result = await ApiHelper.get(`/ketqua/getKQTTMB?ngay=${ngay}`)
        return result.data
    },
    getThongKeDbMb: async (payload) => {
        const { ngay, denNgay } = payload
        let result = await ApiHelper.get(`/parser/thongKeBoSoLauChuaRaRest?tuNgay=${ngay}&denNgay=${denNgay}`)
        return result.data
    },
    getThongKeDbMbRaNhieu: async (payload) => {
        const { ngay, denNgay } = payload
        let result = await ApiHelper.get(`/parser/thongKeBoSoRaNhieuRest?tuNgay=${ngay}&denNgay=${denNgay}`)
        return result.data
    },
    insertThuocTinhDacBiet: async (payload) => {
        const { ngay, denNgay } = payload
        let result = await ApiHelper.post(`/parser/insertThuocTinhDacBiet?ngay=${ngay}`)
        return result.data
    },
    getThongKeDbMbKhachChoi: async (payload) => {
        const { ngay, timeTo, loaiCuocIds } = payload
        let url = `/parser/thongKeKhachChoiDbMb?ngay=${ngay}&timeTo=${timeTo}`
        for (let loai of loaiCuocIds) {
            url += `&loaiCuocIds=${loai}`
        }
        let result = await ApiHelper.get(url)
        return result.data
    },
    getThongKeDbMbKhachChoiAvg: async (payload) => {
        const { ngay, timeTo, loaiCuocIds } = payload
        let url = `/parser/thongKeKhachChoiDbMbAvg?ngay=${ngay}&&timeTo=${timeTo}`
        for (let loai of loaiCuocIds) {
            url += `&loaiCuocIds=${loai}`
        }
        let result = await ApiHelper.get(url)
        return result.data
    },
    freezeBetDe: async (payload) => {
        let result = await ApiHelper.post(`/parser/freezeBetDe`, payload)
        return result.data
    },
    getFreezeBetDe: async (date) => {
        let result = await ApiHelper.get(`/parser/getFreezeBetDe?ngay=${date}`)
        return result.data
    }
}
